import React from 'react';
import {
    BuildCircle,
    SupportAgent,
    AutoAwesome,
    ChangeCircle,
    Star,
    Rocket,
    Diamond,
    CloudQueue,
    Terminal,
    Api,
    VerifiedUser,
    ChildCare,
    Language,
    BusinessCenter,
    Groups2,
    FactCheck,
    HelpOutline,
    MenuBook,
    Storefront,
    Shield,
    SettingsBackupRestore,
} from '@mui/icons-material';
import { SvgIconProps } from '@mui/material';

/**
 * Global Icon Mapper for CMS-driven UI.
 * Translates icon string identifiers from the database into React components.
 */
const iconMap: Record<string, React.ComponentType<SvgIconProps>> = {
    BuildCircle,
    SupportAgent,
    AutoAwesome,
    ChangeCircle,
    Star,
    Rocket,
    Diamond,
    CloudQueue,
    Terminal,
    Api,
    VerifiedUser,
    ChildCare,
    Language,
    BusinessCenter,
    Groups2,
    FactCheck,
    MenuBook,
    Storefront,
    Shield,
    SettingsBackupRestore,
};

/**
 * Returns a React element for the given icon name.
 * @param name - The identifier (e.g. 'BuildCircle')
 * @param props - Optional MUI SvgIconProps
 */
export const getIconByName = (name: string, props?: SvgIconProps): React.ReactElement => {
    const IconComponent = iconMap[name] || HelpOutline;
    return <IconComponent {...props} />;
};
